<template>
  <div class="single-group-wrapper card">
    <page-header
      title="Group"
      breadcrumbText="Dashboard >> Settings >> Users and Groups >> View Group"
    />
    <div class="group-details">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-9 col-lg-9 col-12">
            <div class="container-fluid">
              <div class="row pb-2">
                <div class="pl-0 col-md-6 col-lg-6 col-12">
                  <p>
                    <span class="text-primary-blue font-semibold"
                      >Group Name:</span
                    ><span class="pl-2">{{ group.groupName }}</span>
                  </p>
                </div>
                <div class="pl-0 col-md-6 col-lg-6 col-12">
                  <p>
                    <span class="text-primary-blue font-semibold"
                      >Group Description:</span
                    ><span class="pl-2">{{ group.groupDescription }}</span>
                  </p>
                </div>
              </div>
              <div class="row pb-2">
                <div class="pl-0 col-md-6 col-lg-6 col-12">
                  <p>
                    <span class="text-primary-blue font-semibold"
                      >Group Type:</span
                    ><span class="pl-2">{{ group.groupType }}</span>
                  </p>
                </div>
                <div class="pl-0 col-md-6 col-lg-6 col-12">
                  <p>
                    <span class="text-primary-blue font-semibold"
                      >Group Email ID:</span
                    ><span class="pl-2">{{ group.groupEmailId }}</span>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="pl-0 col-md-6 col-lg-6 col-12">
                  <p>
                    <span class="text-primary-blue font-semibold"
                      >Created By:</span
                    ><span class="pl-2">-</span>
                  </p>
                </div>
                <div class="pl-0 col-md-6 col-lg-6 col-12">
                  <p>
                    <span class="text-primary-blue font-semibold"
                      >Date Created:</span
                    ><span class="pl-2">{{
                      group.createdAt | formatDate
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-lg-3 col-12">
            <div class="group-details__col-three">
              <button
                class="button button-secondary button-long deactivate"
                @click="deactivateGroup"
              >
                Deactivate
              </button>
              <button
                class="button button-secondary button-long delete"
                @click="deleteGroup"
              >
                Delete Group
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <data-table
      :groupMembers="groupMembers"
      :loading="loading"
      @update="getGroupDetails"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/PageHeader";
import DataTable from "./SingleGroupDataTable";
export default {
  components: {
    PageHeader,
    DataTable,
  },
  data() {
    return {
      groupMembers: [],
      group: {},
      loading: true,
    };
  },
  mounted() {
    this.getGroupDetails();
  },
  methods: {
    async getGroupDetails() {
      this.loading = true;
      let groupId = localStorage.getItem("groupId");
      if (groupId) {
        try {
          let response = await this.$_getSingleGroupDetails(groupId);
          console.log(response);
          this.group = response.data.group;
          this.groupMembers = this.group.groupusers;
          this.loading = false;
        } catch (error) {
          this.handleError(error);
          this.loading = false;
        }
      } else {
        this.$router.push({ name: "UsersAndGroups" });
      }
    },
    async deleteGroup() {
      try {
        await this.$_deleteGroup(this.group.id);
        this.generateToast("Group has been deleted!", "success");
        this.$router.push({ name: "UsersAndGroups" });
      } catch (error) {
        this.handleError(error);
      }
    },
    async deactivateGroup() {
      try {
        await this.$_deactivateGroup(this.group.id);
        this.generateToast("Group has been deactivated!", "success");
        this.$router.push({ name: "UsersAndGroups" });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
.single-group-wrapper {
  padding: 1rem 2rem;
}
.group-details {
  margin: 2rem 3.5rem;
}
.group-details p {
  font-size: 0.9rem;
}
.back-btn {
  display: flex;
  align-items: flex-start;
}
.users-and-groups__header {
  display: flex;
}
.group-details__col-three {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
/* button.deactivate {
  width: 80%;
} */
button.delete {
  margin-top: 0.5rem;
  width: 100%;
}
</style>
